var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLicensePlateBigLessWhiteSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 16,
    viewBox: "0 0 54 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.0501 15H2.94972C1.87299 15 1 14.1027 1 12.9957V3.00426C1 1.89741 1.87299 1 2.94972 1H51.0501C52.127 1 53 1.89741 53 3.00426V12.9957C53 14.1027 52.127 15 51.0501 15Z",
    stroke: "#193232",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9.5C28 10.3284 27.3284 11 26.5 11C25.6715 11 25 10.3284 25 9.5V6.5C25 5.6716 25.6715 5 26.5 5C27.3284 5 28 5.6716 28 6.5V9.5Z",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 9.5C40 10.3284 39.3284 11 38.5 11C37.6715 11 37 10.3284 37 9.5V6.5C37 5.6716 37.6715 5 38.5 5C39.3284 5 40 5.6716 40 6.5V9.5Z",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49 6.5C49 7.3284 48.3284 8 47.5 8C46.6715 8 46 7.3284 46 6.5C46 5.6716 46.6715 5 47.5 5C48.3284 5 49 5.6716 49 6.5Z",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49 9.5C49 10.3284 48.3284 11 47.5 11C46.6715 11 46 10.3284 46 9.5C46 8.6716 46.6715 8 47.5 8C48.3284 8 49 8.6716 49 9.5Z",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0472 6.12504C30.2137 5.47812 30.8009 5 31.5 5C32.3283 5 33 5.67172 33 6.5001C33 7.32848 32.3283 8.00007 31.5 8.00007C30.6715 8.00007 30 8.67166 30 9.4999V11H33",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 8C20.3284 8 21 8.6716 21 9.5C21 10.3284 20.3284 11 19.5 11H18V5H19.5C20.3284 5 21 5.6716 21 6.5C21 7.3284 20.3284 8 19.5 8H18",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8C15.3284 8 16 8.6716 16 9.5C16 10.3284 15.3284 11 14.5 11H13V5H14.5C15.3284 5 16 5.6716 16 6.5C16 7.3284 15.3284 8 14.5 8H13",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42 6.12504L43 5V10.8711",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9336 10.9048H44.255",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42871 1V14.6191",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicensePlateBigLessWhiteSpace);
export default __webpack_public_path__ + "static/media/license-plate-big-less-white-space.67b8eb2b0b92eefdcbd17dbd037f0e57.svg";
export { ForwardRef as ReactComponent };